// extracted by mini-css-extract-plugin
module.exports = {"comp":"TabA1_comp__mwpeN"};